// extracted by mini-css-extract-plugin
module.exports = {"textarea":"Textarea_textarea__Tk_vb","default":"Textarea_default__eXaQY","fullWidth":"Textarea_fullWidth__GZ__U","noResize":"Textarea_noResize__38oDn"};